<div class="container">
  <div class="form__name">Billing Form</div>
  <div class="form__container">
    <form [formGroup]="billingForm" >
      <section class="form__personal">
        <div class="sections">
          <div class="box">1</div>
          <span>Personal Information</span>
        </div>
        <div class="personal--form">
          <div class="first">
            <label for="firstname">First Name</label>
            <input
              placeholder="e.g. Richard"
              formControlName="firstName"
              type="text"
            />
          </div>
          <div class="last">
            <label for="lastName">Last Name</label>
            <input
              placeholder="e.g. Bovell"
              formControlName="lastName"
              type="text"
            />
          </div>
          <div class="email">
            <label for="firstname">Email</label>
            <input
              placeholder="e.g. rb@apple.com"
              formControlName="email"
              type="email"
            />
          </div>
          <!-- </form> -->
        </div>
      </section>
      <section class="form__billing">
        <div class="sections">
          <div class="box billing">2</div>
          <span>Billing Address</span>
        </div>
        <div class="shipping--form">
            <div class="row one">
              <div class="address">
                <label for="address-one">Address</label>
                <input
                  placeholder="e.g. 1 Infinite Loop"
                  formControlName="address"
                  type="text"
                />
              </div>
              <div class="address-two">
                <label for="address-two">Phone</label>
                <input formControlName="phone" type="tel" />
              </div>
            </div>
            <div class="row two">
              <div class="city">
                <label for="city">City</label>
                <input
                  placeholder="e.g. Cupertino"
                  formControlName="city"
                  type="text"
                />
              </div>
              <div class="state">
                <label for="state">State / Province / Region</label>
                <input
                  placeholder="e.g. California"
                  formControlName="state"
                  type="text"
                />
              </div>
            </div>
            <div class="row three">
              <div class="zip">
                <label for="zip">Zip / Postal Code</label>
                <input
                  placeholder="e.g. 95014"
                  formControlName="zip"
                  type="text"
                />
              </div>
              <div class="country">
                <label for="country">Country</label>
                <input
                  placeholder="e.g. U.S.A"
                  formControlName="country"
                  type="text"
                />
              </div>
            </div>
        </div>
      </section>
      <section class="form__shipping">
        <div class="sections">
          <div class="box">3</div>
          <span>Order Details</span>
        </div>
        <div class="shipping--form">
          <!-- <form class="form--shipping" action=""> -->
            <div class="row one">
              <div class="address">
                <label for="address-one">Order number</label>
                <input
                  placeholder=""
                  formControlName="orderNo"
                  type="text"
                  readonly
                />
              </div>
              <div class="address-two">
                <label for="address-two">Amount</label>
                <input
                  formControlName="amount"
                  type="amount"
                  value="{amount | 'currency': 'NG'}"
                  readonly
                />
              </div>
            </div>
            <div class="row two">
              <div class="city">
                <label for="city">Currency</label>
                <input
                  placeholder=""
                  formControlName="currency"
                  type="text"
                  readonly
                />
              </div>
              <div class="state">
                <label for="state">Description</label>
                <input
                  placeholder=""
                  formControlName="description"
                  type="text"
                  readonly
                />
              </div>
            </div>
          <!-- </form> -->
        </div>
      </section>
      <div style="display: flex; flex-direction: row">
        <div class="form__confirmation">
          <button (click)="cancel()">Cancel</button>
        </div>
        <div class="form__confirmation">
          <button (click)="checkout()">Confirm Information</button>
        </div>
      </div>
    </form>
  </div>
</div>
